import ValuePlanPageMetaTags from "@/components/MetaTags/ValuePlanPageMetaTags";
import { useBreadcrumbs } from "@/hooks";
import config from "@/lib/config";
import routes from "@/lib/routes";
import dynamic from "next/dynamic";
import { useEffect } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Canvas = dynamic(() => import("@/components/Canvas"), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/Canvas")]
  }
});
export var __N_SSP = true;
export default function ValuePlan() {
  const {
    setBreadcrumbs
  } = useBreadcrumbs();
  useEffect(() => {
    setBreadcrumbs([{
      text: "ホーム",
      href: routes.home
    }, {
      text: config.valuePlan.text
    }]);
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ValuePlanPageMetaTags, {}), /*#__PURE__*/_jsx(Canvas, {
      idKey: config.canvas.valuePlan.vod
    })]
  });
}